import React from 'react';
import Dashboard from './Dashboard';
import {DieselRoute} from 'epic-diesel-common/src/hocs';

class DashboardView extends React.Component {
    static propTypes = {};

    render() {
        return <Dashboard />;
    }
}

export default DieselRoute(DashboardView, {path: 'dashboard'});
